import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IInitializeUserNlpOnboardingStageParams {
  nlpOnboardingStage: string;
}

export class InitializeUserNlpOnboardingStageRequest extends Request<IInitializeUserNlpOnboardingStageParams, IResult> {
  constructor(params: IInitializeUserNlpOnboardingStageParams) {
    super('updateUserNlpOnboardingStage', params);
  }
}
